// Cancellation reasons for the "Cancel Case" flow.
// `id` is the enum value sent to the backend and stored on the STATE_CHANGE
// case activity; `label` is what the user sees in the dropdown.
// `requiresPaidAmount` toggles the "Paid amount" field (payment outside Fair
// Licensing needs an amount so it can still count into the payment rate).
const CancellationReasons = [
  { id: "INVALID_CONTACT_DETAILS", label: "Invalid contact details" },
  {
    id: "PAYMENT_OUTSIDE_FAIR_LICENSING",
    label: "Payment outside Fair Licensing",
    requiresPaidAmount: true,
  },
  { id: "VALID_LICENSE", label: "Valid license" },
  { id: "CASE_INACTIVITY", label: "Case inactivity" },
  { id: "NOT_PURSUING", label: "Not pursuing the case" },
  { id: "OTHER", label: "Other" },
];

export const CANCELLATION_REASON_OTHER = "OTHER";
export const CANCELLATION_REASON_NOT_PURSUING = "NOT_PURSUING";
export const CANCELLATION_REASON_PAYMENT_OUTSIDE_FAIR_LICENSING =
  "PAYMENT_OUTSIDE_FAIR_LICENSING";
export const CANCELLATION_REASON_VALID_LICENSE = "VALID_LICENSE";
export const CANCELLATION_REASON_CASE_INACTIVITY = "CASE_INACTIVITY";

export default CancellationReasons;
